import { createStore, applyMiddleware  } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'

import { API } from 'aws-amplify'
import { message } from 'antd'
import rootReducer from './reducers'
import { InitialRootState } from './states'
import * as CientOrderActions from '../store/client-order/actions';
import * as mutations from '../graphql/mutations'

const updateOrderDB = async(order) => {
  try {
    await API.graphql({ query: mutations.updateOrder, variables: {input: order, id: order.id}})
    message.success('Статус успешно установлен.')
  } catch (err) {
    console.log('err:', err)
    message.error('Статус не установлен. Произошла  ошибка сервера.')
  } 
  
}

const updateOrderMiddleware = store => next => action => {
  if (action.type === CientOrderActions.UPDATE_ORDER) {
    const orderId = action.payload
    const {clientOrder: {orders}} = store.getState()
    const order = orders.find(({id}) => id === orderId)
    const orderToSave = {...order, items: JSON.stringify(order.items)}
    delete orderToSave.createdAt
    delete orderToSave.updatedAt
    delete orderToSave.owner
    delete orderToSave.totalItemsPrice

    updateOrderDB(orderToSave)
    
  }

  next(action);
}

const composedEnhancer = composeWithDevTools(
  // Add whatever middleware you actually want to use here
  applyMiddleware(updateOrderMiddleware)
  // other store enhancers if any
)

export default function configureStore(preloadedState = InitialRootState) {
  return createStore(
    rootReducer,
    preloadedState,
    composedEnhancer
  )
}